module.exports = __webpack_public_path__ + "img/maeshiro-bannerseminar-min.0e88d935.jpg";